import React, { Component } from "react";
import {
    DataGrid,
    FilterRow,
    Editing,
    Column,
    Paging,
    Pager,
    StateStoring,
} from "devextreme-react/data-grid";
import uiInfo from "../../ui-info";
import PaginaToolbar from "../../components/PaginaToolbar";
import { criarPrefeituraDs } from "../../DataSources";


const localStorageKey = "cadastroPrefeiturasGridState";

let _prefeituraCorrente = undefined;

export default class PrefeituraBox extends Component {

    constructor() {
        super();
        this._gridInstance = React.createRef();
        this.onAtualizandoRow = this.onAtualizandoRow.bind(this);
    }

    onAtualizandoRow(e) {
        e.cancel = true;
        this.props.history.push("prefeituras/editar/" + e.data.id);
    }

    render() {
        return (
            <React.Fragment>
                <div className={'content-block dx-card responsive-paddings'}>
                    <PaginaToolbar titulo="PREFEITURAS" novoCb={this.novaPrefeitura.bind(this)}>
                        <DataGrid
                            ref={grid => this._gridInstance = grid}
                            dataSource={criarPrefeituraDs()}
                            showBorders={true}
                            rowAlternationEnabled={true}
                            remoteOperations={true}
                            columnAutoWidth={true}
                            columnHidingEnabled={true}
                            focusedRowEnabled={true}
                            wordWrapEnabled={window.innerWidth < 800}
                            filterSyncEnabled={true}
                            onEditingStart={this.onAtualizandoRow}>
                            <StateStoring enabled={true} type={'localStorage'} storageKey={localStorageKey} />
                            <FilterRow visible={true} />
                            <Editing allowDeleting={true} allowUpdating={true} mode />
                            <Column dataField={'id'} caption={"#"} alignment={'center'} allowEditing={false}/>
                            <Column dataField={'nome'} />
                            <Column dataField={'cnpj'} caption={"CNPJ"} />
                            <Column dataField={'cep'} caption={"CEP"} />
                            <Column dataField={'febraban'} caption={"Febraran"}/>
                            <Column dataField={'prefeituraOrgao'} caption={"Órgão"} />
                            <Column dataField={'logradouro'} caption={"Logradouro"} />
                            <Column dataField={'enderecoComplemento'} caption={"Complemento"} />
                            <Column dataField={'enderecoNumero'} caption={"N.º"} />
                            <Column dataField={'bairro'} caption={"Bairro"} />
                            <Column dataField={'nomeMunicipio'} caption = {"Município"} />
                            <Column dataField={'lei'} caption={"Lei"} />
                            <Column dataField={'decreto'} caption={"Decreto"}/>
                            <Column dataField={'prefeituraLogo'} caption={"Logotipo"} />
                            <Column dataField={'prefeituraLogoNfse'} caption={"Logotipo Nfse"}/>
                            <Column dataField={'prefeituraTopo'} caption={"Topo"} />
                            <Column dataField={'prefeituraTopoNfse'} caption={"Topo Nfse"} />
                            <Column dataField={'prefeituraBrasao'} caption={"Brasão"} />
                            <Column dataField={'prefeituraBrasaoNfse'} caption={"Brasão Nfse"} />
                            <Column dataField={'prefeituraSituacao'} caption={"Situação"} />
                            <Column dataField={'estadoId'} caption={"Id do Estado"} />
                            <Column dataField={'nomeEstado'} caption={"Estado"} />
                            <Column dataField={'municipioId'} caption={"Id do Municipio"} />
                            <Column dataField={'prefeituraEnderecoTipo'} caption={"Tipo de Endereço"} />
                            <Column dataField={'prefeituraEnderecoPais'} caption={"País"} />
                            <Column dataField={'prefeituraInformacoesPagamento'} caption={"Info. Pagamento"} />
                            <Column dataField={'diaVencimento'} caption={"Vencimento"} />
                            <Paging defaultPageSize={uiInfo.tamanhoPaginaPadrao} />
                            <Pager
                                showPageSizeSelector={true}
                                allowedPageSizes={uiInfo.tamanhoPaginaOpcoes}
                            />
                        </DataGrid>
                    </PaginaToolbar>
                </div>
            </React.Fragment>
        );
    }

    novaPrefeitura() {
        let gridState = this._gridInstance.instance.state();
        localStorage.setItem(localStorageKey, JSON.stringify(gridState));
        this.props.history.push("prefeituras/novo");
    }
}